#import "../../../../../graphql/fragments/peep-legacy-id-fragment.graphql"

mutation UpdateContactLegacyId($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
        contact {
            ...PeepLegacyIdFragment
        }
    }
}
